import { BaseModel } from "../../common/base/model";

export class OrderModel extends BaseModel {
	constructor(data) {
		super(data, {
			oldOwners: null,
			newOwners: null,
			consultantEmail: null,
			toTransfer: {
				funds: null,
				securities: null,
				type: null,
			},
			bankData: {
				legacyBankIdentifier: null,
				oldAccountNumber: null,
				portfolioId: null,
				investmentId: null,
				newBlz: null,
			},
			options: {
				deadline: null,
				disposeSecuritiesAccount: null,
				transferCapitalLoss: null,
				transferCapitalLossFromShares: null,
				transferCapitalLossFromForeignTaxes: null,
				disposeExemptionOrder: null,
				disposeSavingsPlan: null,
				sellFragments: null,
				fragmentsProceedsDestinationBankName: null,
				fragmentsProceedsDestinationAccount: null,
			},
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/overview/order.model.js